import React from 'react';
import './SharedFileSection.scss';

// Replace with your actual photo (team reviewing files around a desk)
const aboutImage = 'assets/Unfm/pexels-photo-7792755.avif';

const SharedFileSection = () => {
  return (
    <section className="about-section">
      <div className="container">

        <div className="row align-items-center">

          {/* Left */}
          <div className="col-lg-5">

            <div className="about-content">

              <h2>
                Un dossier unique, partagé en temps réel entre les bons acteurs
              </h2>

              <p>
                UNFM 2.0 connecte quatre acteurs principaux — femme candidate,
                assistant social, association, formateur — dans un écosystème
                collaboratif. Un dossier unique est créé pour chaque femme,
                partagé selon des droits d'accès précis, et suivi de
                l'orientation jusqu'à l'insertion professionnelle.
              </p>

            </div>

          </div>

          {/* Right */}
          <div className="col-lg-7">

            <div className="about-image">

              <img
                src={aboutImage}
                alt="UNFM Collaboration"
              />

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default SharedFileSection;